






















import Vue from 'vue';
import NOC from '@/class/common/const';
// import * as models from '@/class/models/views/app';

export default Vue.extend({
  name: 'Thanks',
  async mounted() {
    // console.log('thanks');
    // await setTimeout(await this.onClickMoveLogin, 10000);
    if (process.env.VUE_APP_MODE === 'PROD') {
      (this as any).$gtm.trackView( location.pathname.toString() , location.toString());
      const GTA = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PZGPC3J');`;
      const GTABody = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PZGPC3J" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      const gtaScript: any = document.createElement('script');
      gtaScript.type = '';
      gtaScript.innerText = GTA;
      gtaScript.id = 'lp_gta';
      document.head.appendChild(gtaScript);
      const gtaBodyScript: any = document.createElement('noscript');
      gtaBodyScript.type = '';
      gtaBodyScript.innerText = GTABody;
      gtaBodyScript.id = 'lp_gta2';
      document.body.appendChild(gtaBodyScript);
    }
  },
  destroyed() {
    if (process.env.VUE_APP_MODE === 'PROD') {
      (document.getElementById('lp_gta') as HTMLInputElement).remove();
      (document.getElementById('lp_gta2') as HTMLInputElement).remove();
    }
  },
  methods: {
    async onClickMoveWELCOME() {
      this.$emit('change', NOC.APP.MODE.WELCOME);
    },
  },
});
